module.exports = __webpack_public_path__ + "img/KW.3c06184f.svg";